import { FirebaseAnalytics } from "@capacitor-firebase/analytics";
import { useEffect } from "react";
import { useCustomRouter } from "shared/context/CustomRouterContext";
import { useCustomSession } from "shared/context/CustomSessionContext";
import { getDeviceInfo } from "hub/src/utils/getDeviceInfo";

export function FirebaseAnalyticsProvider() {
  const router = useCustomRouter();
  const session = useCustomSession();

  useEffect(() => {
    if (!getDeviceInfo().isNativeApp) {
      return;
    }

    FirebaseAnalytics.setCurrentScreen({ screenName: router.pathname });
  }, [router.pathname]);

  useEffect(() => {
    if (!getDeviceInfo().isNativeApp) {
      return;
    }

    const userId = session?.profileId?.toString() || null;
    FirebaseAnalytics.setUserId({ userId });
  }, [session?.profileId]);

  return null;
}
